import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-promo-video',
  templateUrl: './homeone-main-banner.component.html',
  styleUrls: ['./homeone-main-banner.component.scss']
})
export class HomeoneMainBannerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
